export default __webpack_public_path__ + "static/media/post3.c460f10c.png";